import * as _cloneDeep from 'lodash/cloneDeep';

export function cloneDeep<T>(obj: T): T {
  return _cloneDeep(obj);
}
